import { useEffect, useMemo, useState } from 'react';
import { Corn } from './components/Corn';
import { Soy } from './components/Soy';
import { Sorghum } from './components/Sorghum';

import * as S from './style'
import { useHeaderStates } from '../../Providers/HeaderStates';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../Api';
import { Capa } from '../../components/Capa';

// A foto do topo vinha como URL dentro do markdown do HeroSection; a Capa
// quer o id do asset, que é o trecho depois de /api/assets/<app>/.
const idDoAsset = (url) => url?.match(/\/api\/assets\/(?:[^/]+\/)?([0-9a-f-]{36})/i)?.[1];

// URL da imagem dentro do markdown de cada fundo da lista.
function extractImageUrl(markdown) {
  const regex = /!\[]\((.*?)\s*"/;
  const match = markdown.match(regex);
  return match ? match[1] : null;
}

export const GrainCommercial = () => {
  const [fade, setFade] = useState(false);

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [indexCards, setIndexCards] = useState(1)


  const [data, setData] = useState(null);

  const { setTitle, setBgHeader } = useHeaderStates()

  const { token, setError, setLoading } = useStartupState();


  useEffect(() => {
    if (hoveredIndex !== null) {
      setFade(false);
      const timeout = setTimeout(() => setFade(true), 10);
      return () => clearTimeout(timeout);
    } else {
      setFade(false);
    }
  }, [hoveredIndex]);

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/comercialdegraos/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token, setError, setLoading]);

  // A página tem a própria Capa: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  const items = data?.listaBg?.iv;
  // Calculadas uma vez por lista (e não a cada render), para o efeito abaixo
  // poder depender delas sem rodar à toa.
  const backgrounds = useMemo(
    () => (items || []).map((item) => extractImageUrl(item.bg.conteudo)),
    [items],
  );

  useEffect(() => {
    backgrounds.forEach((url) => {
      if (url) {
        const img = new Image();
        img.src = url;
      }
    });
  }, [backgrounds]);

  const background = hoveredIndex !== null ? backgrounds[hoveredIndex] : null;

  return (
    <>
      <Capa
        rota="/comercialDeGraos"
        imagem={
          idDoAsset(data?.HeroSection?.iv?.conteudo && extractImageUrl(data.HeroSection.iv.conteudo)) ||
          data?.imagemHeader?.iv?.[0]
        }
        titulo={data?.seo?.iv?.TituloSEO}
      />
      <S.GrainComponent>

        <S.GrainCommercialTitle>
          <h2>{data?.HeroSection?.iv?.titulo}</h2>
          <p>{data?.conteudoMarkdown?.iv}</p>
        </S.GrainCommercialTitle>

        <S.Container background={`${baseUrlImg}${data?.seo?.iv?.metaImagens[0]}`}>
          <S.BackgroundOverlay key={hoveredIndex} fade={fade} background={background} />
          <S.Grid style={{ position: 'relative', zIndex: 1 }}>
            {items?.map((text, index) => (
              <S.GridItem
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => {
                  setTimeout(() => {
                    setHoveredIndex((current) => {

                      return current === index ? null : current;
                    });
                  }, 100)
                }}
                onClick={() => setIndexCards(index)}
                background={backgrounds[index]}
              >
                <div className="faixa"></div>
                {text?.bg?.titulo}

                <div className="subtitle">{text?.bg?.subTitulo}</div>
              </S.GridItem>
            ))}
          </S.Grid>
        </S.Container>
      </S.GrainComponent>

      {
        indexCards !== -1 ? <S.TabsGrain>
          {
            items?.map((dataSource, index) => <S.TabsSingle style={{ background: index === indexCards ? "green" : "gray" }} key={index} onClick={() => { setIndexCards(index); }}></ S.TabsSingle>)
          }
        </S.TabsGrain> : null
      }

      {indexCards === 0 && <Soy />}
      {indexCards === 1 && <Corn />}
      {indexCards === 2 && <Sorghum />}
    </>
  );
};
